module.exports = __webpack_public_path__ + "static/media/subscribe1.816884cb.svg";